import { useAccount, useBalance, useChainId, useSwitchChain } from 'wagmi'
import { useAppKit } from '@reown/appkit/react'
import { getNetworkConfig, formatAddress, isMetaMaskInstalled } from '../services/walletService'

export function useWallet() {
  const { address, isConnected } = useAccount()
  const chainId = useChainId()
  const { data: balance } = useBalance({ address })
  const { switchChain } = useSwitchChain()
  const { open, close } = useAppKit()

  // Get current network configuration
  const currentNetwork = getNetworkConfig(chainId)
  const isNetworkSupported = currentNetwork.chainId !== undefined

  // Wallet actions
  const connectWallet = () => {
    open()
  }

  const disconnectWallet = () => {
    close()
  }

  // Network actions
  const switchToBSCTestnet = async () => {
    try {
      await switchChain({ chainId: 97 }) // BSC Testnet
    } catch (error) {
      console.error('Failed to switch to BSC Testnet:', error)
      throw error
    }
  }

  const switchToBSCMainnet = async () => {
    try {
      await switchChain({ chainId: 56 }) // BSC Mainnet
    } catch (error) {
      console.error('Failed to switch to BSC Mainnet:', error)
      throw error
    }
  }

  const switchToNetwork = async (targetChainId) => {
    try {
      await switchChain({ chainId: targetChainId })
    } catch (error) {
      console.error('Failed to switch network:', error)
      throw error
    }
  }

  // Format balance for display
  const formattedBalance = balance ? `${parseFloat(balance.formatted).toFixed(4)} ${balance.symbol}` : '0 BNB'

  return {
    // Connection state
    isConnected,
    address,
    formattedAddress: formatAddress(address),
    isMetaMaskInstalled: isMetaMaskInstalled(),
    
    // Network state
    chainId,
    network: currentNetwork,
    isNetworkSupported,
    
    // Balance
    balance: balance?.value,
    formattedBalance,
    
    // Actions
    connectWallet,
    
    // Network actions
    switchToBSCTestnet,
    switchToBSCMainnet,
    switchToNetwork,
    
    // AppKit controls
    openModal: open,
    closeModal: close,
    
    // Utilities
    formatAddress,
    getNetworkConfig,
  }
}

export default useWallet